var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 6.875C14.5605 6.70924 14.6264 6.55027 14.7436 6.43306C14.8608 6.31585 15.0198 6.25 15.1855 6.25H17.6855C17.8513 6.25 18.0103 6.31585 18.1275 6.43306C18.2447 6.55027 18.3105 6.70924 18.3105 6.875V8.125C18.3105 8.29076 18.2447 8.44973 18.1275 8.56694C18.0103 8.68415 17.8513 8.75 17.6855 8.75H15.1855C15.0198 8.75 14.8608 8.68415 14.7436 8.56694C14.6264 8.44973 14.5605 8.29076 14.5605 8.125V6.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31055 2.5C2.64751 2.5 2.01162 2.76339 1.54278 3.23223C1.07394 3.70107 0.810547 4.33696 0.810547 5L0.810547 15C0.810547 15.663 1.07394 16.2989 1.54278 16.7678C2.01162 17.2366 2.64751 17.5 3.31055 17.5H18.3105C18.9736 17.5 19.6095 17.2366 20.0783 16.7678C20.5472 16.2989 20.8105 15.663 20.8105 15V5C20.8105 4.33696 20.5472 3.70107 20.0783 3.23223C19.6095 2.76339 18.9736 2.5 18.3105 2.5H3.31055ZM19.5605 5V11.25H2.06055V5C2.06055 4.66848 2.19224 4.35054 2.42666 4.11612C2.66108 3.8817 2.97903 3.75 3.31055 3.75H18.3105C18.6421 3.75 18.96 3.8817 19.1944 4.11612C19.4289 4.35054 19.5605 4.66848 19.5605 5ZM18.3105 16.25H3.31055C2.97903 16.25 2.66108 16.1183 2.42666 15.8839C2.19224 15.6495 2.06055 15.3315 2.06055 15V13.75H19.5605V15C19.5605 15.3315 19.4289 15.6495 19.1944 15.8839C18.96 16.1183 18.6421 16.25 18.3105 16.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicEx);
export default __webpack_public_path__ + "static/media/academicEx.48fc445bfbf9bccfb66416f0ab7d9466.svg";
export { ForwardRef as ReactComponent };